var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinMascot021Diwali(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 111,
    viewBox: "0 0 89 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0859 61.127V90.0206",
    stroke: "#E6E6E6",
    strokeWidth: 8.29124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4805 61.127V90.0206",
    stroke: "#E6E6E6",
    strokeWidth: 8.29124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2503 35.748C14.2503 35.748 3.9319 40.8938 4.15174 46.4917C4.34819 51.5163 14.7461 53.1942 14.7461 53.1942",
    stroke: "#8E020F",
    strokeWidth: 8.29124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8162 56.4805L25.4375 59.7758C25.0025 64.5906 23.5946 68.2728 19.8854 69.261C14.5906 70.897 10.1844 67.6809 10.1844 64.7351C10.1844 63.5 11.5689 63.2063 11.5689 63.2063C11.5689 63.2063 9.65589 61.9805 11.1573 60.3957C11.742 59.7758 13.337 60.3584 13.337 60.3584C13.337 60.3584 13.6504 58.7131 14.5718 58.4055C15.1238 58.2237 16.4709 58.8389 16.4709 58.8389L20.8162 56.4805Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1792 50.4163C17.1792 50.4163 17.544 51.4463 17.2213 52.7654C16.8611 54.2429 16.0425 54.9561 16.0425 54.9561C14.9853 55.7485 14.7701 57.2493 15.5654 58.3027C16.3606 59.3561 17.8668 59.5705 18.924 58.7781C18.924 58.7781 21.0524 57.2866 21.885 53.898C22.6054 50.9476 21.6418 48.6497 21.6418 48.6497C21.1506 47.4239 19.7566 46.8273 18.5264 47.312C17.2961 47.8014 16.6974 49.1904 17.1839 50.4163H17.1792Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8546 63.7746H44.9998C60.3511 63.7746 72.8164 51.3529 72.8164 36.0555C72.8164 20.758 60.3511 8.33643 44.9998 8.33643",
    fill: "#AA7C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0574 57.0584L58.0943 57.1237L61.4716 53.6046L66.5938 53.5254L63.0574 57.0631V57.0584Z",
    fill: "#E7BB29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4688 58.3906L56.3326 58.4512L53.4745 60.2224L59.3918 59.7749L61.4688 58.3906Z",
    fill: "#E7BB29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2305 24.3748L64.8932 24.0672C64.3459 22.7761 62.3438 19.7931 60.875 18.1431L66.5912 18.5905C67.798 20.1799 69.4119 22.7715 70.2305 24.3748Z",
    fill: "#F3E9A4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8553 63.7741C24.4926 63.7741 12.0387 51.3638 12.0387 36.055C12.0387 20.7462 24.4926 8.33594 39.8553 8.33594C55.218 8.33594 67.6719 20.7462 67.6719 36.055C67.6719 51.3638 55.218 63.7741 39.8553 63.7741Z",
    fill: "#ECD559"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8553 63.7741C24.4926 63.7741 12.0387 51.3638 12.0387 36.055C12.0387 20.7462 24.4926 8.33594 39.8553 8.33594C55.218 8.33594 67.6719 20.7462 67.6719 36.055C67.6719 51.3638 55.218 63.7741 39.8553 63.7741Z",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4807 36.0556C19.2899 14.0043 39.9641 12.9043 39.6647 12.9043C26.8393 12.9043 16.432 23.2797 16.432 36.0556C16.432 48.8314 26.8439 59.2068 39.6647 59.2068C39.9641 59.2068 18.8643 57.953 18.4807 36.0556Z",
    fill: "#A67705"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8567 59.3976C26.9197 59.3976 16.4322 48.9469 16.4322 36.0553C16.4322 23.1636 26.9197 12.7129 39.8567 12.7129C52.7937 12.7129 63.2812 23.1636 63.2812 36.0553C63.2812 48.9469 52.7937 59.3976 39.8567 59.3976Z",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8546 63.7745H44.9998C60.3511 63.7745 72.8164 51.3529 72.8164 36.0555C72.8164 20.758 60.3511 8.33643 44.9998 8.33643",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8.33643H39.8545",
    stroke: "#0B1420",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2891 4.64467C48.012 3.20908 45.2849 2.3095 42.8805 2.97136",
    stroke: "white",
    strokeWidth: 3.68639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6698 5.93088C28.741 4.33681 31.3184 3.07834 33.793 3.41393",
    stroke: "white",
    strokeWidth: 3.68639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9301 34.7363C70.9301 34.7363 86.3095 39.8541 84.5929 46.5147C83.1616 52.08 70.7851 51.9215 70.7851 51.9215",
    stroke: "#8E020F",
    strokeWidth: 8.29124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8198 38.6792C45.8198 38.6792 42.4053 40.6928 38.7896 40.4317C35.174 40.1707 31.9466 38.9961 31.9466 38.9961C31.9466 38.9961 31.3198 43.5919 33.8596 47.7868C36.3995 51.9817 38.7101 52.7415 41.1049 52.3406C43.4998 51.9398 46.3998 49.2737 47.3867 45.0508C45.773 43.5733 44.9778 40.8932 45.8104 38.6792H45.8198Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9297 38.5586C41.6592 40.8425 36.7386 40.9963 31.8179 39.2764C31.8507 40.5116 31.9021 41.6209 32.1219 42.7628C34.1379 44.8743 41.6686 44.8323 45.6116 42.0217C45.2328 40.9077 45.4573 39.9056 45.9297 38.5586Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1074 49.6978C40.4067 49.0592 40.8418 48.2575 42.1422 48.0198C43.8823 47.7029 45.1406 48.924 45.1406 48.924C45.1406 48.924 44.2051 51.6228 40.8932 52.0982C37.5065 52.5876 36.3979 49.9215 36.3979 49.9215C36.3979 49.9215 36.6365 48.994 37.7872 48.4859C38.6245 48.1177 39.6583 48.2529 40.6266 48.7842",
    fill: "#FF7EB9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1074 49.6978C40.4067 49.0592 40.8418 48.2575 42.1422 48.0198C43.8823 47.7029 45.1406 48.924 45.1406 48.924C45.1406 48.924 44.2051 51.6228 40.8932 52.0982C37.5065 52.5876 36.3979 49.9215 36.3979 49.9215C36.3979 49.9215 36.6365 48.994 37.7872 48.4859C38.6245 48.1177 39.6583 48.2529 40.6266 48.7842",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2969 36.0559C53.1591 34.4525 48.5703 34.7275 46.5308 37.5334C43.2189 42.0826 48.5141 47.2283 52.0458 48.0114",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9297 38.5581C40.6348 41.5319 35.0032 41.0471 29.0723 37.5327",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4102 45.0555C46.6945 48.0106 44.4026 52.2288 40.2864 52.3407C34.0842 52.5132 31.3385 43.2191 31.9887 39.0195",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4854 35.4684C31.8249 35.4684 28.8575 31.7455 28.8575 27.1531C28.8575 22.5608 31.8249 18.8379 35.4854 18.8379C39.1459 18.8379 42.1133 22.5608 42.1133 27.1531C42.1133 31.7455 39.1459 35.4684 35.4854 35.4684Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7148 33.525C40.074 32.8771 38.7362 31.6513 37.0615 31.4042C35.1015 31.1152 33.3193 31.7445 32.758 33.2733C32.0283 35.2682 33.6187 37.65 36.0839 38.2839C37.2393 38.5822 38.6192 38.5309 39.7886 37.9902",
    fill: "#ECD559"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7148 33.525C40.074 32.8771 38.7362 31.6513 37.0615 31.4042C35.1015 31.1152 33.3193 31.7445 32.758 33.2733C32.0283 35.2682 33.6187 37.65 36.0839 38.2839C37.2393 38.5822 38.6192 38.5309 39.7886 37.9902",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9815 35.4679C41.321 35.4679 38.3536 31.745 38.3536 27.1527C38.3536 22.5603 41.321 18.8374 44.9815 18.8374C48.642 18.8374 51.6094 22.5603 51.6094 27.1527C51.6094 31.745 48.642 35.4679 44.9815 35.4679Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7201 23.9746C43.0361 23.9746 41.6655 25.6899 41.6655 27.806C41.6655 29.9221 43.0315 31.6373 44.7201 31.6373C46.3106 31.6373 47.5127 29.978 47.625 28.9992L44.9353 27.764L47.5782 26.4543C47.3584 25.303 46.2076 23.9746 44.7201 23.9793V23.9746Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4467 23.3638C33.7627 23.3638 32.3921 25.079 32.3921 27.1951C32.3921 29.3112 33.758 31.0265 35.4467 31.0265C37.0371 31.0265 38.2393 29.3672 38.3516 28.3883L35.6619 27.1532L38.3048 25.8434C38.0849 24.6922 36.9342 23.3638 35.4467 23.3684V23.3638Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4226 93.8755L41.0718 106.428L43.5788 106.274L62.6955 106.428C62.6955 106.428 63.5608 100.117 60.0293 96.9937C56.4979 93.8755 52.5735 94.0107 50.1834 94.0107C47.7932 94.0107 41.4226 93.8755 41.4226 93.8755Z",
    fill: "#88CAFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7664 93.8755L38.1172 106.428L35.6101 106.274L16.4935 106.428C16.4935 106.428 15.6282 100.117 19.1596 96.9937C22.6911 93.8755 26.6154 94.0107 29.0056 94.0107C31.3957 94.0107 37.7664 93.8755 37.7664 93.8755Z",
    fill: "#88CAFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8279 94.3367C42.8279 94.3367 41.2702 98.2566 43.5764 102.074C45.831 105.807 50.9766 106.143 50.9766 106.143L41.0691 106.269L41.4199 93.8706L42.8279 94.332V94.3367Z",
    fill: "#4A97CC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3583 94.3367C36.3583 94.3367 37.916 98.2566 35.6099 102.074C33.3552 105.807 28.2097 106.143 28.2097 106.143L38.1172 106.269L37.7664 93.8706L36.3583 94.332V94.3367Z",
    fill: "#4A97CC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9692 58.4286L71.2368 58.6896C72.6119 59.8222 73.3322 60.6006 73.0797 61.5328L73.6082 61.9383C73.6082 61.9383 75.3529 60.6146 76.4147 61.1832C79.4129 62.8006 77.1163 65.1731 77.1163 65.1731C77.1163 65.1731 78.5382 67.2099 76.3211 68.1515C74.8197 68.79 69.768 71.3023 64.1551 65.6438C56.6993 58.1163 64.1271 48.5193 65.839 48.4214C65.839 48.4214 65.1888 56.3032 69.9692 58.4333V58.4286Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6815 93.7634C50.6815 93.7634 46.8226 95.4273 42.1031 94.1456C40.8262 93.796 40.0731 92.4816 40.4239 91.2091C40.7747 89.9367 42.0938 89.1862 43.3707 89.5358C46.3643 90.3515 48.8199 89.3634 48.8199 89.3634C50.0407 88.8506 51.4486 89.4193 51.9631 90.6358C52.4776 91.8523 51.907 93.2553 50.6862 93.768L50.6815 93.7634Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8026 93.7634C37.8026 93.7634 33.9437 95.4273 29.2242 94.1456C27.9473 93.796 27.1942 92.4816 27.545 91.2091C27.8958 89.9367 29.2149 89.1862 30.4918 89.5358C33.4854 90.3515 35.941 89.3634 35.941 89.3634C37.1618 88.8506 38.5697 89.4193 39.0842 90.6358C39.5987 91.8523 39.0281 93.2553 37.8073 93.768L37.8026 93.7634Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7966 49.6243C70.7966 49.6243 70.4317 50.6543 70.7545 51.9734C71.1147 53.451 71.9333 54.1641 71.9333 54.1641C72.9905 54.9565 73.2056 56.4573 72.4104 57.5107C71.6152 58.5641 70.109 58.7785 69.0518 57.9861C69.0518 57.9861 66.9234 56.4946 66.0908 53.106C65.3704 50.1556 66.334 47.8577 66.334 47.8577C66.8252 46.6319 68.2192 46.0353 69.4494 46.52C70.6797 47.0094 71.2784 48.3984 70.7919 49.6243H70.7966Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3396 107.64C40.3396 106.885 40.9524 106.274 41.7101 106.274H62.0709C62.8287 106.274 63.4414 106.885 63.4414 107.64V108.978C63.4414 109.733 62.8287 110.343 62.0709 110.343H41.7101C40.9524 110.343 40.3396 109.733 40.3396 108.978V107.64Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8555 107.64C38.8555 106.885 38.2427 106.274 37.485 106.274H17.1242C16.3664 106.274 15.7537 106.885 15.7537 107.64V108.978C15.7537 109.733 16.3664 110.343 17.1242 110.343H37.485C38.2427 110.343 38.8555 109.733 38.8555 108.978V107.64Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3396 107.64C40.3396 106.885 40.9524 106.274 41.7101 106.274H62.0709C62.8287 106.274 63.4414 106.885 63.4414 107.64V108.978C63.4414 109.733 62.8287 110.343 62.0709 110.343H41.7101C40.9524 110.343 40.3396 109.733 40.3396 108.978V107.64Z",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8555 107.64C38.8555 106.885 38.2427 106.274 37.485 106.274H17.1242C16.3664 106.274 15.7537 106.885 15.7537 107.64V108.978C15.7537 109.733 16.3664 110.343 17.1242 110.343H37.485C38.2427 110.343 38.8555 109.733 38.8555 108.978V107.64Z",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M62.697 106.428C62.697 106.428 64.0207 99.2032 58.3797 95.6795C53.3562 92.5426 46.4944 93.8757 43.5804 99.3104",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4928 106.427C16.4928 106.427 15.1691 99.2027 20.81 95.679C25.8336 92.5421 32.6953 93.8752 35.6094 99.3099",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M41.071 106.428L41.4219 93.8755",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1172 106.428L37.7664 93.8755",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9491 58.4287C70.0707 59.7152 69.4813 61.8779 68.4475 62.8007",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7854 62.4002C68.6507 62.7451 69.9651 64.493 69.9651 64.493C70.6994 65.001 72.0091 65.0243 72.8557 64.7167C72.8557 64.7167 74.5115 63.7985 76.2188 64.4697C77.8044 65.0896 77.767 67.2337 76.4901 68.0493C75.0307 68.9815 71.3168 70.1002 67.3177 68.026C61.2417 64.8705 59.7075 57.8324 62.2427 52.5142C63.0612 50.7989 64.6001 49.2654 66.1717 48.1841",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1113 65.173C78.1217 63.7933 78.2059 62.134 76.9008 61.3975C75.4928 60.6005 74.3608 61.4348 72.8452 62.4369C71.4185 63.3785 69.8327 63.5136 69.0609 63.4018",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5508 61.8349C73.5508 61.8349 73.0035 61.5972 72.3065 61.8442C71.3943 62.1705 70.0752 62.259 69.1256 61.9001",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8344 58.4287C71.6576 58.974 73.6317 60.0647 72.93 61.738",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16.344 59.104C15.8388 61.0803 16.5404 63.7743 17.9531 65.1074",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 59.771C25.2785 61.9337 24.4693 67.1447 21.3073 68.7015C18.9359 69.8668 15.7786 70.0346 13.7299 69.0045C11.611 67.9418 9.98798 65.7651 10.2078 64.5905C10.3996 63.5511 11.2181 63.1782 12.1583 63.2994C13.5522 63.4765 14.4315 64.6371 15.3156 65.6066",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1133 64.2505C17.1133 64.2505 16.8466 64.3996 16.7905 64.4369C16.5707 64.5674 16.3602 64.7212 16.159 64.8751C15.5462 65.3365 15.013 65.8679 14.5686 66.4878",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.57 63.2017C11.6121 63.2297 10.8777 62.7263 10.6626 62.1064C10.3819 61.2907 10.7421 60.4005 11.6496 60.1721C13.6189 59.6687 16.4022 62.2882 17.0664 63.9475",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5431 60.3906C12.8321 59.6681 13.9968 57.7198 15.8398 58.6473",
    stroke: "black",
    strokeWidth: 0.918452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinMascot021Diwali);
export default __webpack_public_path__ + "static/media/Coin_Mascot_02 1_diwali.de5b94156e39d49b6b55e50b02c8ac79.svg";
export { ForwardRef as ReactComponent };